/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id, teamIdentifier: ZodTypes.Team.Identifier });

export const PostTeamGroups = {
  id: 'team-groups.post',
  tag: 'Team',
  summary: 'Add team groups',
  description: 'Add new OIDC groups to an organization team',
  method: 'post',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/team/${params.teamIdentifier}/group`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({ groups: z.array(z.strictObject({ groupName: z.string().min(1) })) }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: { 'application/json': { schema: z.string().optional() } },
    },
  },
} as const satisfies Endpoint;
